export default __webpack_public_path__ + "static/media/campus2.70ebb068.png";